import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"padding":"30px"} }
const _hoisted_2 = { class: "pl-24 pr-24" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "d-flex flex-row-reverse" }
const _hoisted_5 = {
  class: "d-flex justify-content-between",
  style: {"padding":"30px 0 0 0"}
}
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "parent" }
const _hoisted_8 = { class: "mt-80 mb-50" }
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_back_svg = _resolveComponent("back-svg")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_QuizFilters = _resolveComponent("QuizFilters")!
  const _component_document_card_checkbox = _resolveComponent("document-card-checkbox")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_ciena_layout = _resolveComponent("ciena-layout")!
  const _component_the_modal = _resolveComponent("the-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ciena_layout, { "no-sidebar": true }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: "heading-4 heading-4 f-roboto fw-light d-flex cursor-p mr-16",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: _ctx.rDashboard }))),
                onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$router.push({ name: _ctx.rDashboard })), ["enter"]))
              }, [
                _createVNode(_component_back_svg, { class: "mr-6" }),
                _createElementVNode("div", null, _toDisplayString(_ctx.name), 1)
              ], 32)
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "d-flex justify-content-center" }, null, -1)),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_base_button, {
                class: "ml-18",
                onClick: _ctx.save
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("Save now", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_base_button, {
                variant: "outlined",
                onClick: _ctx.cancel
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("Cancel", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[8] || (_cache[8] = _createElementVNode("h4", { class: "heading-4 f-roboto fw-light grey-1 mb-32" }, "Add new question to specific partner", -1)),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_base_button, {
                class: "mr-16",
                variant: "outlined",
                onClick: _ctx.selectAll
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode("Select all", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_base_button, {
                variant: "outlined",
                onClick: _ctx.deselectAll
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("Deselect all", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_QuizFilters, { onOnFilterChange: _ctx.onFilterChange }, null, 8, ["onOnFilterChange"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (document) => {
              return (_openBlock(), _createElementBlock("div", {
                key: document.id,
                class: "child"
              }, [
                _createVNode(_component_document_card_checkbox, {
                  id: document.id,
                  name: document.name,
                  "gradient-type": document.color,
                  "last-edited": document.updated_at,
                  "filter-values": document.filter_values,
                  "business-function-id": _ctx.businessFunctionId,
                  "is-selected": _ctx.savedQuizIds.indexOf(document.id) !== -1,
                  onOnCheck: _ctx.toggleQuiz
                }, null, 8, ["id", "name", "gradient-type", "last-edited", "filter-values", "business-function-id", "is-selected", "onOnCheck"])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_ctx.pageMeta.current_page)
              ? (_openBlock(), _createBlock(_component_pagination, {
                  key: 0,
                  "current-page": _ctx.pageMeta.current_page,
                  "total-pages": _ctx.pageMeta.total,
                  meta: _ctx.pageMeta,
                  onHandleClick: _ctx.navigateToPage
                }, null, 8, ["current-page", "total-pages", "meta", "onHandleClick"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_the_modal, { "is-visible": _ctx.questionCreateConfirmIsOpen }, {
      content: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("p", null, "Your question has been saved to " + _toDisplayString(_ctx.numberOfPartnersThatQuestionBeenSaved) + " selected Partners.", 1),
          _cache[9] || (_cache[9] = _createElementVNode("p", null, [
            _createTextVNode("This process takes a few minutes to save. During this "),
            _createElementVNode("br"),
            _createTextVNode(" time it will not be possible to edit and you won't see your saved changes")
          ], -1)),
          _cache[10] || (_cache[10] = _createElementVNode("p", null, [
            _createTextVNode("On the dashboard, located on the Partner title the icon below "),
            _createElementVNode("br"),
            _createTextVNode(" indicates your edits are being configured. When the icon is not "),
            _createElementVNode("br"),
            _createTextVNode(" displayed the configuration is completed.")
          ], -1)),
          _createElementVNode("img", {
            class: "processing-icon",
            src: require('@/assets/img/process.png'),
            alt: "processing",
            width: "24",
            height: "24"
          }, null, 8, _hoisted_9)
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_base_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'dashboard'})))
        }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
            _createTextVNode("I understand, back to dashboard", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-visible"])
  ], 64))
}